import { $onload } from '../../../utils/dom.ts';
import formSubmitHandler from '../../form-submit-handlers/index.ts';

$onload(
    '.view-blocks-PardotFormSolutions2Block-form',
    HTMLFormElement,
    ($el, { $OrThrow }) => {
        formSubmitHandler({
            handler: JSON.parse($el.dataset.handler || ''),
            $form: $el,
            $message: $OrThrow('-message', HTMLElement),
        });
    },
);
